import { TrackingState, SerialiseType, DataType, RelationType } from '../Model/Misc';
import { Utils } from '../Utils';
import NumberUtils from "../NumberUtils";
var Deserialiser = /** @class */ (function () {
    function Deserialiser() {
        this.objectRefs = {};
        this.suspendedObjects = [];
        this.options = {};
    }
    /**
     * Called before an object is deserialised. Object tracking should be suspended here. Must return the property info list.
     */
    Deserialiser.prototype.beginObjectDeserialise = function (object) {
        var neoTypeInfo = object.constructor.neo;
        if (!neoTypeInfo) {
            throw "Tried to deserialise into an object without @NeoModel decorator.";
        }
        var propertyMap = neoTypeInfo === null || neoTypeInfo === void 0 ? void 0 : neoTypeInfo.propertyMap;
        if (propertyMap && object.isSuspended !== undefined) {
            object.isSuspended = true;
            this.suspendedObjects.push(object);
        }
        return propertyMap;
    };
    /**
     * Called after an object has been deserialised. Object tracking should be re-enabled here.
     */
    Deserialiser.prototype.endObjectDeserialise = function (object, wasCreated) {
        if (object.onDeserialiseCompleted !== undefined) {
            object.onDeserialiseCompleted(wasCreated);
        }
    };
    Deserialiser.prototype.deserialise = function (from, to, rootType, options, justCreated) {
        var _this = this;
        if (options === void 0) { options = {}; }
        if (justCreated === void 0) { justCreated = false; }
        this.options = options;
        this.objectRefs = {};
        this.suspendedObjects = [];
        try {
            Utils.batchUpdate(function () {
                if (from instanceof Array) {
                    _this.deserialiseArray(from, to, rootType);
                }
                else {
                    _this.deserialiseObject(from, to, justCreated);
                }
            });
        }
        catch (error) {
            throw "Deserialise error. ".concat(error);
        }
        finally {
            this.cleanUp();
        }
    };
    Deserialiser.prototype.cleanUp = function () {
        var _this = this;
        Utils.nextTick(function () {
            for (var _i = 0, _a = _this.suspendedObjects; _i < _a.length; _i++) {
                var obj = _a[_i];
                obj.isSuspended = false;
            }
        });
    };
    Deserialiser.prototype.deserialiseArray = function (from, to, type) {
        if (!to) {
            throw "Cannot deserialise array into a non initialised property.";
        }
        else if (!(to instanceof Array)) {
            throw "Tried to deserialise array into a non array type.";
        }
        //create an index of the to objects
        var toIndex = {};
        for (var i = 0; i < to.length; i++) {
            toIndex[to[i].entityIdentifier] = to[i];
        }
        if (this.options.removeOldItems) {
            to.length = 0;
        }
        for (var i = 0; i < from.length; i++) {
            var fromItem = from[i];
            var toItem = null;
            var addToList = true;
            var deserialise = true;
            var hasIdentifier = false;
            // find the object, if not found, create a new instance.
            if (fromItem.entityIdentifier && fromItem.entityIdentifier !== Utils.emptyGuid()) {
                toItem = toIndex[fromItem.entityIdentifier];
                hasIdentifier = true;
            }
            if (toItem) {
                // its already in the list
                addToList = false;
            }
            else {
                if (fromItem.$ref) {
                    toItem = this.getReferencedObject(fromItem.$ref);
                    deserialise = false;
                }
                else {
                    if (type) {
                        toItem = new type();
                    }
                    else {
                        toItem = to.createChild();
                    }
                }
            }
            if (deserialise)
                this.deserialiseObject(fromItem, toItem, addToList);
            if (addToList || this.options.removeOldItems) {
                to.push(toItem);
                if (hasIdentifier) {
                    toIndex[fromItem.entityIdentifier] = toItem;
                }
            }
        }
        var list = to;
        if (list.deletedList) {
            list.clearDeletedList();
        }
    };
    Deserialiser.prototype.deserialiseDictionary = function (from, to, parentProperty) {
        for (var key in from) {
            var fromItem = from[key];
            if (fromItem.$ref) {
                to[key] = this.getReferencedObject(fromItem.$ref);
            }
            else {
                var mustCreate = !to[key];
                if (mustCreate) {
                    to[key] = parentProperty.createValueInstance();
                }
                this.deserialiseObject(fromItem, to[key], mustCreate);
            }
        }
    };
    Deserialiser.prototype.deserialiseObject = function (from, to, justCreated) {
        if (!from || !to) {
            throw "From and to objects are required.";
        }
        if (to instanceof Array) {
            throw "Tried to deserialise object into an array type.";
        }
        var typeName = to.constructor.name;
        var propertyInfoList = this.beginObjectDeserialise(to);
        if (from.$id) {
            this.objectRefs[from.$id] = { from: from, to: to };
        }
        if (!propertyInfoList)
            propertyInfoList = {};
        for (var key in from) {
            if (from.hasOwnProperty(key)) {
                var propertyInfo = propertyInfoList[key];
                var canDeserialise = this.options.allowExtraProperties;
                if (propertyInfo) {
                    canDeserialise = !propertyInfo.isComputed && !propertyInfo.isReadOnly &&
                        ((propertyInfo.serialise === SerialiseType.Always) ||
                            (propertyInfo.serialise === SerialiseType.NotNull) ||
                            (propertyInfo.serialise === SerialiseType.MappingOnly && !!this.options.isMap) ||
                            (propertyInfo.serialise === SerialiseType.FullOnly && (this.options.removeOldItems || justCreated)));
                }
                if (canDeserialise) {
                    try {
                        var fromValue = from[key];
                        if (propertyInfo) {
                            if (fromValue && propertyInfo.propertyType === DataType.Date) {
                                to[key] = new Date(fromValue);
                            }
                            else if (fromValue !== null && propertyInfo.propertyType === DataType.Decimal) {
                                to[key] = NumberUtils.decimalService.createDecimal(fromValue);
                            }
                            else {
                                if (fromValue instanceof Array && !propertyInfo.assignOnDeserialise) {
                                    if (!to[key] || !(to[key] instanceof Array) || to[key].childObjectType) {
                                        // Deserialise into full list.
                                        this.deserialiseArray(fromValue, to[key], undefined);
                                    }
                                    else {
                                        // Plain array
                                        to[key] = fromValue;
                                    }
                                }
                                else if (propertyInfo.relationType === RelationType.Dictionary) {
                                    if (!to[key]) {
                                        to[key] = {};
                                    }
                                    this.deserialiseDictionary(fromValue, to[key], propertyInfo);
                                }
                                else if (fromValue instanceof Object && !propertyInfo.assignOnDeserialise) {
                                    // Properties of type Parent are ignored. Parent will be set when the item is added to a list.
                                    if (propertyInfo.relationType !== RelationType.Parent) {
                                        if (fromValue.$ref) {
                                            to[key] = this.getReferencedObject(fromValue.$ref);
                                        }
                                        else {
                                            var mustCreate = !to[key];
                                            if (mustCreate) {
                                                to[key] = propertyInfo.createValueInstance();
                                            }
                                            this.deserialiseObject(fromValue, to[key], mustCreate);
                                        }
                                    }
                                }
                                else {
                                    // Simple value, or null
                                    to[key] = fromValue;
                                }
                            }
                        }
                        else {
                            // No type information, set raw value.
                            to[key] = fromValue;
                        }
                    }
                    catch (error) {
                        throw "Error deserialising property '".concat(key, "' on type '").concat(typeName, "': ").concat(error);
                    }
                }
            }
        }
        //ignore empty guids
        if (to.entityIdentifier !== undefined) {
            var toModel = to;
            if ((!this.options.isMap || this.options.isMap.includeEntityIdentifiers) &&
                from.entityIdentifier && from.entityIdentifier.indexOf('000000000000') === -1) {
                toModel.entityIdentifier = from.entityIdentifier;
            }
            if (!this.options.isMap) {
                if (!from.trackingState) {
                    toModel.isSelfDirty = false;
                    toModel.isNew = false;
                }
                else if (from.trackingState === TrackingState.Deleted) {
                    //TODO: handle deleted objects coming from server?
                }
                else {
                    toModel.isSelfDirty = true;
                    toModel.isNew = from.trackingState === TrackingState.Added;
                }
            }
        }
        this.endObjectDeserialise(to, justCreated);
    };
    Deserialiser.prototype.getReferencedObject = function (id) {
        var found = this.objectRefs[id];
        if (!found) {
            throw "Cannot find $id: ".concat(id, ".");
        }
        return found.to;
    };
    return Deserialiser;
}());
export { Deserialiser };
